import { COMPLAINTS_COMPLAINT_LOADING, COMPLAINTS_COMPLAINT_LOADED, } from "../actions";
const initialState = {
    loadingState: "NOT_LOADED",
    data: {},
};
export const complaint = (state = initialState, { type, payload }) => {
    switch (type) {
        case COMPLAINTS_COMPLAINT_LOADING:
            return Object.assign(Object.assign({}, state), { loadingState: "LOADING" });
        case COMPLAINTS_COMPLAINT_LOADED:
            return Object.assign(Object.assign({}, state), { loadingState: "LOADED", data: payload.response, roles: payload.roles || Object.assign({}, state.roles) });
        default:
            return state;
    }
};
